import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {saveDeepLink} from './utils/routerUtils';

function ProtectedRoute({children}) {
    const isAuthenticated = useSelector(s=>s.auth.isLoggedIn);
    const location = useLocation();
    if(isAuthenticated)
        return children;
    // Idempotent, validated write — safe under StrictMode double-render.
    saveDeepLink(location.pathname + location.search + location.hash);
    return <Navigate to="/login" replace />;
}

export default ProtectedRoute;
